import { makeStyles } from '@material-ui/core/styles';
import culture1 from '../../img/culture-1.jpg';
import culture2 from '../../img/culture-2.jpg';
import culture3 from '../../img/culture-icon1.svg';
import culture4 from '../../img/culture-icon2.svg';
import bio1 from '../../img/team-photo1.jpg';
import bio2 from '../../img/team-photo2.jpg';
import bio3 from '../../img/team-photo3.jpg';
import bio4 from '../../img/team-photo4.jpg';
import bio5 from '../../img/team-photo5.jpg';
import bio6 from '../../img/team-photo6.jpg';
import bio7 from '../../img/team-photo7.jpg';

const whoClasses = makeStyles((theme) => ({
  expertise: {
    position: 'absolute', 
    bottom: 0, 
    width: '100%',  
    height:'100%', 
    borderRadius: "0 0 10px 10px ", 
    display:'flex',
    backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,.7)85%, rgba(0,0,0,.9) 100%)',
    '&:hover': {
      backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0.3) 40%, rgba(0,0,0,.7)85%, rgba(0,0,0,.9) 100%)',
      borderRadius: "10px",

    },
  },

  
  expertiseInner: {
    alignSelf: 'flex-end', 
    margin: '0 auto', 
    color: 'white',
  },

  expertiseInnerMargin: {
    marginBottom: 8,
  },

  modalButton: {
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    padding: 0,
    margin: 0,
    minHeight: '100%',
    border: 0,
    borderRadius: 30,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,.35)',
      color: '#FFF',         
    },
  },
  cultureImage1: {
    backgroundImage:`url(${culture1})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: 30,
    minHeight: 300,
  },
  bioImage1: {
    backgroundImage:`url(${bio1})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  bioImage2: {
    backgroundImage:`url(${bio2})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  bioImage3: {
    backgroundImage:`url(${bio3})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  bioImage4: {
    backgroundImage:`url(${bio4})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  bioImage5: {
    backgroundImage:`url(${bio5})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  bioImage6: {
    backgroundImage:`url(${bio6})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  bioImage7: {
    backgroundImage:`url(${bio7})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    borderRadius: 30,
    minHeight: 500,
  },
  cultureIcon1: {
    backgroundImage:`url(${culture3})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    borderRadius: 30,
    minHeight: 300,
  },
  cultureIcon2: {
    backgroundImage:`url(${culture4})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    borderRadius: 30,
    minHeight: 300,
  },
  cultureImage2: {
    backgroundImage:`url(${culture2})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: 30,
    minHeight: 300,
  },
  teamInfo: {
    alignSelf: 'flex-end',
    padding: 20,
    paddingTop: 40,
    width: '100%',
    borderRadius: "0 0 30px 30px ",
    backgroundImage: 'linear-gradient(180deg, rgba(2,0,36,0) 0%, rgba(0,0,0,.7) 65%, rgba(0,0,0,.9) 100%)',

  },
  bioName: {
    fontWeight: 700,
    marginBottom: 0,
    color: 'white',
  },
  bioTitle: {
    fontWeight: 400,
    lineHeight: 1.4,
    marginBottom: 0,
    color: 'white',
  },
  closeButton: {
    display: 'flex', 
    justifyContent: 'flex-end',
  },

  modalInner: {
    paddingLeft: 60,
    paddingRight: 60,
    paddingTop: 30,
    paddingBottom: 30,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 20,
      paddingRight: 20,
       },
  },

  modalPadding: {
    paddingLeft: 40,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingTop: 24,
      },
  },

  expertiseButton: {
    padding: 0, 
    margin: '0 auto', 
    width: '100%',
    height: '100%',
  },
  
  viewButtonLabel: { 
    height: '100%',
  },

  fullWidthCard: {
    transform: 'scale: (1.5)',
  },

  title: {
    lineHeight: 1.2,
    marginTop: '8px',
  },

  
rightArrow: {
  position: 'absolute',
  top: '50%',
  right: '20px',
  fontSize: '2rem',
  color: '#B64C4C',
  zIndex: '10',
  cursor: 'pointer',
  userSelect: 'none',
  [theme.breakpoints.down('xs')]: {
    fontSize: '1.5rem',
    right: 10,
  },
},

leftArrow: {
  position: 'absolute',
  top: '50%',
  left: '20px',
  fontSize: '2rem',
  color: '#B64C4C',
  zIndex: '10',
  cursor: 'pointer',
  userSelect: 'none',
  [theme.breakpoints.down('xs')]: {
    fontSize: '1.5rem',
    left: 10,
  },
}



  }));
  export default whoClasses